<template>
    <div>
        <MainPage @clickBack="clickBack()" customClass="pb-0 max-w-5xl min-h-screen lg:relative">
            <div class="pb-0 lg:pb-12">
                <div>
                    <div class="map map-area " id="map"></div>
                    <div class="absolute w-full px-4 wrapper-search max-w-5xl" :class="[cookieClass]">
                        <div class="flex shadow-text bg-white p-2 rounded-5">
                            <img class="mr-2" src="@/assets/icon/icon-search-gray.svg"/>
                            <input class="w-full placeholder-a-brown-9f8273 text-a-brown-502314 text-14 lg:text-16"
                                id="search-input"
                                type="text"
                                :placeholder="lbl.shipping.search_your_location">
                        </div>
                    </div>
                    <div class="absolute info-address px-4 w-full flex">
                        <div v-if="addressText"
                            class="bg-white text-14 lg:text-16 rounded-10 p-4 m-auto shadow-text">
                            {{addressText}}
                        </div>
                    </div>
                </div>
                <div class="px-4 flex">
                    <div class="wrap-btn-select">
                        <RedButton @click="clickSelectLocation()">{{lbl.shipping.select_location}}</RedButton>
                    </div>
                </div>
                <div class="control-map">
                    <img class="btn-current-map" src="../../../../assets/map/current-location.svg" @click="clickCurrentLocation()">
                </div>
            </div>
        </MainPage>
    </div>
</template>

<script>
//lib
import { Loader } from '@googlemaps/js-api-loader'; //https://www.npmjs.com/package/@googlemaps/js-api-loader
//helper
import Util from "@/helper/Utility.js";
import Location from "@/helper/LocationHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import RedButton from "@/components/Button/RedButton.vue";
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import CookieMixin from '@/mixin/CookieMixin.js';
// svg icon
import iconPinMap from "@/assets/icon/ic-pin-map.svg"

export default {
    name: "Location",
    inject: ['DeliveryStore'],
    mixins: [ModalMixin,LocaleMixin,CookieMixin],
    components: {
        MainPage,
        RedButton
    },
    data: function() {
        return {
            currentLocation: {
                lat: 13.7451765,
                lng: 100.5081332
            },
            isLoaded: false,

            map: null,
            searchBox: null,
            googleloader: null,
            googleMaps: null,
            geocoder: null,
            marker: null,
            addressResults: null,
            addressText: ''
        };
    },
    created: async function() {
        await this.initialMaps();
        this.pinCurrent();
        this.modal.loadingModal.hide();
        this.clickCurrentLocation();
    },
    mounted: function() {
        Util.scrollTop();
        this.modal.loadingModal.show();
    },
    methods: {
        getCurrentLocation: function() {
            return new Promise((resolve) => {
                Location.getCurrentLocation().then((location) => {
                    this.currentLocation = location
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    resolve();
                });
            });
        },
        initialMaps: function () {
            return new Promise((resolve) => {
                var key = ConfigManager.getGoogleMapsKey()
                const loader = new Loader({
                    apiKey: key,
                    version: "weekly",
                    libraries: ["places"]
                });
                loader.load().then((google) => {
                    this.geocoder = new google.maps.Geocoder();
                    this.searchBox = new google.maps.places.SearchBox(document.getElementById("search-input"));
                    this.map = new google.maps.Map(document.getElementById("map"), {
                        center: {
                            lat: this.currentLocation.lat,
                            lng: this.currentLocation.lng,
                        },
                        zoom: 15,
                        mapTypeId: "roadmap",
                        disableDefaultUI: true,
                        fullscreenControl: false,
                        clickableIcons: false,
                        clickableLabels: false,
                        zoomControl: true,
                    });
                    this.map.addListener('click', (e) => {
                        this.pinChange(e.latLng);
                    });
                    this.map.addListener('bounds_changed', () => {
                        this.addressText = "";
                    });
                    this.searchBox.addListener('places_changed', () => {
                        let places = this.searchBox.getPlaces();
                        if (places.length == 0) return;

                        this.pinChange(places[0].geometry.location);
                    });

                    this.googleMaps = google;

                    resolve(true);
                })
                .catch(e => {
                    console.log(e);
                    // do something
                });
            });
        },
        pinChange: async function(latLng) {
            this.currentLocation.lat = latLng.lat();
            this.currentLocation.lng = latLng.lng();
            this.marker.setPosition(latLng);
            this.map.setCenter(latLng);
            await this.getGeocode(this.currentLocation);
        },
        setPinLocation: async function(lat, lng) {
            this.currentLocation.lat = lat;
            this.currentLocation.lng = lng;
            this.marker.setPosition(this.currentLocation);
            this.map.setCenter(this.currentLocation);
            await this.getGeocode(this.currentLocation);
        },
        pinCurrent: async function(){
            this.marker = new this.googleMaps.maps.Marker({
                position: this.currentLocation,
                icon: iconPinMap
            });
            this.marker.setMap(this.map);

            await this.getGeocode(this.currentLocation);
        },
        getGeocode: function(position) {
            return new Promise((resolve) => {
                this.geocoder.geocode({ 'location': position, 'language': this.localeShort}, (results, status) => {
                    if (status === 'OK') {
                        if (results.length > 0) {
                            this.addressResults = results;
                            this.addressText = this.addressResults[0].formatted_address;
                            console.log(this.addressResults);
                        } else {
                            console.log('No results found');
                        }
                        resolve()
                    } else {
                        console.log('Geocoder failed due to: ' + status);
                        resolve()
                    }
                });
            });
        },
        clickSelectLocation: function() {
            this.DeliveryStore.methods.initAddress();
            this.DeliveryStore.state.address.lat = this.currentLocation.lat;
            this.DeliveryStore.state.address.lng = this.currentLocation.lng;
            this.DeliveryStore.state.address.number = Location.getAddressType(this.addressResults,'street_number');
            this.DeliveryStore.state.address.soi = Location.getAddressType(this.addressResults,'route');
            this.DeliveryStore.state.address.subDistrictName = Location.getSubDistrict(this.addressResults);
            this.DeliveryStore.state.address.districtName = Location.getDistrict(this.addressResults);
            this.DeliveryStore.state.address.provinceName = Location.getAddressType(this.addressResults,'administrative_area_level_1');
            this.DeliveryStore.state.address.zipcode = Location.getAddressType(this.addressResults,'postal_code');

            this.$router.push('/addaddress');
        },
        clickBack: function() {
            this.$router.back();
        },
        clickCurrentLocation: async function () {
            await this.getCurrentLocation();
            this.setPinLocation(this.currentLocation.lat, this.currentLocation.lng);
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .map-area {
        height: calc(100vh - #{$topbar-height});
        @include min-desktop {
            margin-top: 50px;

            height: calc(100vh - 220px);
        }

    }
    .info-address {
        bottom: calc(100vh / 2 + 45px);
        @include min-desktop {
            bottom: calc(100vh / 2 + 5px);
        }
    }

    .wrapper-search {
        top: 72px;
        @include min-desktop {
            top: 140px;
        }

        &.accept-cookie {
            top: 160px;
            @include min-desktop {
                top: 200px;
            }
        }
    }

    .wrap-btn-select {
        width: 100%;
        max-width: 360px;
        position: relative;
        margin: -60px auto;
        height: 0px;

        @include mobile {

            max-width: 200px;
        }
    }

    .control-map {
        position: relative;

        .btn-current-map {
            position: absolute;
            width: 34px;
            right: 12px;
            top: -148px;
        }
    }
</style>
